// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"FeedbackModal_modalWrapper__thz3N","likeAnimation":"FeedbackModal_likeAnimation__2RnGg"};